import React from 'react'
import PropTypes from 'prop-types'
import Helmet from 'react-helmet'

import Header from '../components/Header'
import Footer from '../components/Footer'
import { BlogItems } from '../components/blogContent'

import '../css/bootstrap.min.css'
import '../css/animate.min.css'
import '../css/font-awesome.min.css'
import '../css/et-line-font.css'
import '../css/nivo-lightbox.css'
import '../css/nivo_themes/default/default.css'
import '../css/bxslider.css'
import '../css/style.css'
import '../css/updates.css'


class TemplateWrapper extends React.Component {

  calculateMeta() {
    for (let i = 0; i < BlogItems.length; i++) { 
      if (this.props.location.pathname == BlogItems[i].link) {
        return [
          { name: 'description', content: 'DevExperience Iasi Software Development Conference' },
          { name: 'keywords', content: 'Software Development, Iasi, Senior Developers, Java, .NET, JavaScript, QA' },
          { name: 'og:title', content: BlogItems[i].title },
          { name: 'og:description', content: BlogItems[i].text },
          { name: 'og:image', content: BlogItems[i].image },
        ]
      }
    }

    if (this.props.location.pathname == "/agenda/") {
      return [
        { name: 'description', content: 'DevExperience Iasi Software Development Conference' },
        { name: 'keywords', content: 'Software Development, Iasi, Senior Developers, Java, .NET, JavaScript, QA' },
        { name: 'og:title', content: "Agenda for DevExperience 2019" },
        { name: 'og:description', content: "Here is the schedule for 19 April, the conference day for DevExperience' 4th gathering" },
      ]
    }

    if (this.props.location.pathname == "/tracks/devops/") {
      return [
        { name: 'description', content: 'DevExperience Iasi Software Development Conference' },
        { name: 'keywords', content: 'Software Development, Iasi, Senior Developers, Java, .NET, JavaScript, QA' },
        { name: 'og:title', content: "DevExperience 2019 - DevOps Track" },
        { name: 'og:description', content: "The DevOps track is Powered by Mambu and features speakers like: Viktor Farcic, Daniel Patriche, Yan Cui and Matt Turner" },
      ]
    }
    if (this.props.location.pathname == "/tracks/architecture/") {
      return [
        { name: 'description', content: 'DevExperience Iasi Software Development Conference' },
        { name: 'keywords', content: 'Software Development, Iasi, Senior Developers, Java, .NET, JavaScript, QA' },
        { name: 'og:title', content: "DevExperience 2019 - Architecture Track" },
        { name: 'og:description', content: "The Architecture track is Powered by Centric and features speakers like: Susanne Kaiser, Tudor Teodoru, David Schmitz and Andreas Grabner" },
      ]
    }
    if (this.props.location.pathname == "/tracks/security/") {
      return [
        { name: 'description', content: 'DevExperience Iasi Software Development Conference' },
        { name: 'keywords', content: 'Software Development, Iasi, Senior Developers, Java, .NET, JavaScript, QA' },
        { name: 'og:title', content: "DevExperience 2019 - Security Track" },
        { name: 'og:description', content: "The Security track is Powered by UiPath and features speakers like: Anastasiia Voitova, Pawel Krawczyk, Yan Cui and Christian Wenz" },
      ]
    }
    return [
      { name: 'description', content: 'DevExperience Iasi Software Development Conference' },
      { name: 'keywords', content: 'Software Development, Iasi, Senior Developers, Java, .NET, JavaScript, QA' },
    ]
  }

  render() {
    
    let metaArray = this.calculateMeta();
    return (
    <div>
       <Helmet
       title="DevExperience Conference"
       meta={metaArray}
     />
     <Header />
     {this.props.children()}
     <Footer />
        
      </div>
    )
  }
}

export default TemplateWrapper



// WEBPACK FOOTER //
// ./src/layouts/index.js